import {
  PageHeader,
  PageHeaderActions,
  PageHeaderTitle,
  PageHeaderTop,
} from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import type { DefaultProps } from 'typings'

export function Header(props: DefaultProps) {
  return (
    <PageHeader>
      <PageHeaderTop>
        <PageHeaderTitle>
          <FormattedMessage id="admin/promotions.title" />
        </PageHeaderTitle>
        {props.children}
      </PageHeaderTop>
    </PageHeader>
  )
}

export function HeaderActions(props: DefaultProps) {
  return <PageHeaderActions>{props.children}</PageHeaderActions>
}
